module.exports = __webpack_public_path__ + "5747dc7bd7552ed3fae12cd5d4812fd5.svg";